/**
 * What build this is — the line at the bottom of the settings screen.
 *
 * Two facts, from two places, because no single place knows both. The bundle
 * knows when it was built (`__BUILD_AT__`, stamped by Vite), and that is the
 * whole story on the web, where the service worker replaces builds quietly and
 * a version number would have nothing to number. Inside a shell there is also
 * the shell's own version — the APK's versionName, TestFlight's build — which
 * only the native side can answer, and which matters precisely because it can
 * lag behind the bundle: «почему у тебя не работает» starts with reading this
 * line off both phones.
 */

/** When this bundle was built. Re-exported so components import a value, not a global. */
export const buildAt: string = __BUILD_AT__;

/**
 * «14 августа 2026, 15:42» — in the reader's own timezone, because the question
 * this answers is «это уже сборка с починкой или ещё вчерашняя?», and the fix
 * was deployed on the reader's clock.
 */
export function formatBuiltAt(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

/** The shell's version and build number, or null outside a shell. */
export interface ShellVersion {
  version: string;
  build: string;
}

/**
 * One line out of both facts: «Версия 1.2 (3) · сборка от 14 августа 2026, 15:42»
 * in a shell, only the second half on the web. Pure, so the test can hold the
 * format still without mounting the screen.
 */
export function versionLine(shell: ShellVersion | null, builtAtIso: string): string {
  const built = `сборка от ${formatBuiltAt(builtAtIso)}`;
  if (shell === null) return built.charAt(0).toUpperCase() + built.slice(1);
  return `Версия ${shell.version} (${shell.build}) · ${built}`;
}
